import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { PawPrint } from './PawPrint';
export function Hero() {
  return <section className="relative pt-8 pb-12 md:pt-20 md:pb-32 px-4 overflow-hidden bg-cream" data-id="element-77">
      <PawPrint className="absolute top-10 left-10 w-16 h-16 rotate-[-20deg]" delay={0.2} data-id="element-78" />
      <PawPrint className="absolute bottom-20 right-10 w-24 h-24 rotate-[30deg]" delay={0.4} data-id="element-79" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center relative z-10" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center md:text-left" data-id="element-81">
          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight mb-6" data-id="element-82">
            Tu sillón te costó una fortuna. Tu gato lo está destruyendo gratis.{' '}
            <span className="text-amber" data-id="element-83">Frenalo hoy.</span>
          </h1>
          <p className="text-lg md:text-xl mb-8 text-warmBrown/80 font-medium" data-id="element-84">
            El método de "Enriquecimiento Ambiental de Bajo Costo" para
            transformar tu departamento en un paraíso felino sin gastar un solo
            peso en el Pet Shop.
          </p>
          <Button href="#precio" className="w-full sm:w-auto" data-id="element-85">
            QUIERO MI GUÍA AHORA
          </Button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-86">
          <div className="absolute inset-0 bg-amber/20 rounded-3xl transform rotate-3 scale-105" data-id="element-87"></div>
          <img src="https://cdn.magicpatterns.com/uploads/sQS5QY5k9NqoGZMqxsiFZm/Mockup_3.png" alt="Guía Gato de Depto Feliz en una tablet junto a un gato durmiendo" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl" data-id="element-88" />
        </motion.div>
      </div>
    </section>;
}